import { Box, Typography } from "@mui/material";
import React from "react";
export type TitleAndDetailsViewProps = {
  color?: string;
  title?: string;
  details?: React.ReactNode;
};
export function TitleAndDetailsView({ title = "Title", details = "NA", color }: TitleAndDetailsViewProps) {
  return (
    <div style={{ display: "flex", gap: "1.875rem", justifyContent: "space-between", wordBreak: "break-all" }}>
      <Typography sx={{ color: "text.secondary" }}>{title}</Typography>
      <Typography color={color} sx={{ width: "50%", textAlign: "right", wordBreak: "break-all" }}>
        {details}
      </Typography>
    </div>
  );
}

export default TitleAndDetailsView;
